import React from 'react';
import { ImageFile } from '~/data/types/images';

const InfoIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        stroke="#595959"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.89 1.836H5.11c-2.013 0-3.276 1.426-3.276 3.444v5.445c0 2.018 1.257 3.444 3.277 3.444h5.778c2.021 0 3.278-1.426 3.278-3.444V5.28c0-2.018-1.257-3.444-3.277-3.444z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#595959"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.996 10.67V8.005"
      ></path>
      <path
        stroke="#595959"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M7.994 5.47h.007"
      ></path>
    </Component>
  );
};

export default InfoIcon;
